import { useEffect, useState } from "react";
import { fetchValuationMethods, downloadValuationMethodsExcel } from "../Api/ViewValuationMethod";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewValuationMethod = () => {
  const [valuationMethods, setValuationMethods] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadValuationMethods = async () => {
      try {
        const data = await fetchValuationMethods();
        setValuationMethods(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Valuation Methods`);
      }
    };

    loadValuationMethods();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadValuationMethodsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Valuation_Methods_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Valuation methods data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div>
          <Container className="list-container">
           <div className="header-background">
              <h2 className="header-list-title">View Valuation Methods</h2>
              <Button className="gradient-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || valuationMethods.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {valuationMethods.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {valuationMethods.map((method, index) => {
                    const createdDateTime = method.createdOnDate 
                      ? `${moment(method.createdOnDate).format('L')} at ${method.createdOnTime ? method.createdOnTime.substring(0, 8) : ''}`
                      : '';
                    
                    const changedDateTime = method.changedOnDate 
                      ? `${moment(method.changedOnDate).format('L')} at ${method.changedOnTime ? method.changedOnTime.substring(0, 8) : ''}`
                      : '';

                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{method.code}</td>
                        <td>{method.description}</td>
                        <td>{createdDateTime}</td>
                        <td>{method.createdBy}</td>
                        <td>{changedDateTime || 'N/A'}</td>
                        <td>{method.changedBy || 'N/A'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No valuation methods found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewValuationMethod;